type GradientCircleProps = {
  width?: string;
  height?: string;
};

export default function GradientCircle({ width = '32', height = '32' }: GradientCircleProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      aria-hidden={true}
      data-testid="gradient-circle-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
        fill="url(#paint0_linear_27_163)"
      />
      <defs>
        <linearGradient id="paint0_linear_27_163" x1="25" y1="4.5" x2="6.5" y2="27.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0041D9" />
          <stop offset="1" stopColor="#D03C0B" />
        </linearGradient>
      </defs>
    </svg>
  );
}
